


import { Routes, RouterModule } from '@angular/router';
import { WorkflowComponent } from './workflow.component';

const routes: Routes = [
    {
        path: '',
        component: WorkflowComponent
    },
];

export const WorkflowRoutes = RouterModule.forChild(routes);
